import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/browser";
import App from "./App.tsx";

import store from "./store/index-store.tsx";
import { browserTracingIntegration, replayIntegration } from "@sentry/react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

Sentry.init({
  dsn: sentryDsn,
  integrations: [
    browserTracingIntegration(),
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <Provider store={store}>
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  </Provider>,
  // </React.StrictMode>,
);
